import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const profileSettingsIcon = svgToTinyDataUri(
  `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8214_54110)">
<path d="M8 0C10.5773 0 12.667 2.08966 12.667 4.66699C12.6669 6.09968 12.0202 7.38035 11.0039 8.23633C13.5048 8.95979 15.334 11.266 15.334 14V14.333C15.334 14.8852 14.8861 15.3328 14.334 15.333H1.66699C1.11471 15.333 0.666992 14.8853 0.666992 14.333V14C0.666992 11.2662 2.49549 8.95999 4.99609 8.23633C3.98006 7.38035 3.33408 6.09951 3.33398 4.66699C3.33398 2.08977 5.42282 0.000175808 8 0ZM6.66699 9.33301C4.08966 9.33301 2 11.4227 2 14H14C14 11.4228 11.9112 9.33318 9.33398 9.33301H6.66699ZM8 1.33301C6.1592 1.33318 4.66699 2.82615 4.66699 4.66699C4.66717 6.50768 6.15931 7.99982 8 8C9.84084 8 11.3338 6.50779 11.334 4.66699C11.334 2.82604 9.84095 1.33301 8 1.33301Z" fill="#2B2A35"/>
</g>
<defs>
<clipPath id="clip0_8214_54110">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>`,
);
